module.exports = __webpack_public_path__ + "img/user.197e9b4.svg";